// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .blog-banner {
  background-image: url(../images/contactus-banner.jpg);
} */

.mapse {
  padding: 55px 0px;
  padding-bottom: 0px;
}

.form-grp .form-check {
  margin-bottom: 12px;
}

.form-grp .form-check-input:checked {
  height: 16px;
  width: 16px;
}

.form-grp .form-check label {
  font-size: 15px;
  font-weight: 400;
  color: #7a7a7a;
  line-height: 22px;
  font-family: "Poppins";
}

.quick-inner {
  border: 1px solid #eaeaea;
  padding: 20px 10px;
}

.form-grp input {
  box-shadow: none;
  border: 1px solid #eaeaea;
}

.form-grp textarea.form-control {
  border: 1px solid #eaeaea;
  box-shadow: none;
}

.austrial {
  padding-bottom: 371px;
  height: 692px;
}

.form-grp label {
  font-size: 16px;
}

.austrial ul li a i {
  font-size: 15px;
  margin-right: 15px;
  border: none;
  width: 24px;
  height: 24px;
  text-align: center;
  line-height: 22px;
  color: #55b56d;
  margin-bottom: 25px;
  float: left;
}

.maint-abt-inner img {
  width: 100%;
}

.maint-abt-inner h3 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 52px;
  text-align: left;
  padding-right: 40px;
  position: absolute;
  left: 100px;
  bottom: 130px;
  color: #fff;
}

.maint-abt-inner {
  position: relative;
}

.quick {
  padding-top: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ContactUs/ContactUs.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* .blog-banner {\r\n  background-image: url(../images/contactus-banner.jpg);\r\n} */\r\n\r\n.mapse {\r\n  padding: 55px 0px;\r\n  padding-bottom: 0px;\r\n}\r\n\r\n.form-grp .form-check {\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.form-grp .form-check-input:checked {\r\n  height: 16px;\r\n  width: 16px;\r\n}\r\n\r\n.form-grp .form-check label {\r\n  font-size: 15px;\r\n  font-weight: 400;\r\n  color: #7a7a7a;\r\n  line-height: 22px;\r\n  font-family: \"Poppins\";\r\n}\r\n\r\n.quick-inner {\r\n  border: 1px solid #eaeaea;\r\n  padding: 20px 10px;\r\n}\r\n\r\n.form-grp input {\r\n  box-shadow: none;\r\n  border: 1px solid #eaeaea;\r\n}\r\n\r\n.form-grp textarea.form-control {\r\n  border: 1px solid #eaeaea;\r\n  box-shadow: none;\r\n}\r\n\r\n.austrial {\r\n  padding-bottom: 371px;\r\n  height: 692px;\r\n}\r\n\r\n.form-grp label {\r\n  font-size: 16px;\r\n}\r\n\r\n.austrial ul li a i {\r\n  font-size: 15px;\r\n  margin-right: 15px;\r\n  border: none;\r\n  width: 24px;\r\n  height: 24px;\r\n  text-align: center;\r\n  line-height: 22px;\r\n  color: #55b56d;\r\n  margin-bottom: 25px;\r\n  float: left;\r\n}\r\n\r\n.maint-abt-inner img {\r\n  width: 100%;\r\n}\r\n\r\n.maint-abt-inner h3 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 40px;\r\n  line-height: 52px;\r\n  text-align: left;\r\n  padding-right: 40px;\r\n  position: absolute;\r\n  left: 100px;\r\n  bottom: 130px;\r\n  color: #fff;\r\n}\r\n\r\n.maint-abt-inner {\r\n  position: relative;\r\n}\r\n\r\n.quick {\r\n  padding-top: 0px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
